<template>
    <div id="membership-details-members-tab"
         class="tab-contents">
        <!-- Show reasons why the membership cannot be redeemed -->
        <MembershipUnredeemableInfo v-if="membershipSubscription"
                                    :membership="membership"
                                    :subscription="membershipSubscription" />

        <div class="membership-details__admission-btns-row">
            <!-- Admit All Members button -->
            <button v-if="membershipSubscription"
                    class="btn btn-lg btn-success btn--inline-flex"
                    :disabled="!admitAllEnabled"
                    @click="$emit('log-visit')">
                <i v-if="membership.redemptionActionInProgress"
                   class="fa-solid fa-spinner fa-spin"></i>
                <i v-else
                   class="fa-solid fa-arrow-right-to-bracket"></i>
                <span>{{ l('MEMBERSHIP_DETAILS.ADMIT_ALL_BTN') }}</span>
            </button>

            <!-- Undo All Today's Admissions button -->
            <button v-if="membershipSubscription"
                    class="btn btn-lg btn-danger btn--inline-flex"
                    :disabled="!unadmitAllEnabled"
                    @click="$emit('unlog-visit')">
                <i v-if="membership.currentlyUnredeeming"
                   class="fa-solid fa-spinner fa-spin"></i>
                <i v-else
                   class="fa-solid fa-arrow-rotate-left"></i>
                <span>{{ l('MEMBERSHIP_DETAILS.REMOVE_ADMISSION_BTN') }}</span>
            </button>
        </div>

        <div class="member-tiles"
             :class="{'has-selected-member': !!selectedMember}">
            <MemberTile v-for="(member, index) in membersWithContact"
                        :key="member.ID"
                        :member="member"
                        :membership="membership"
                        :membership-subscription="membershipSubscription"
                        :selected-member="selectedMember"
                        :show-edit-btn="true"
                        :index="index"
                        @edit-member="handleEditMember"
                        @toggle-visit="handleToggleVisit" />
        </div>
    </div>
</template>

<script>
import MembershipUnredeemableInfo from '@/epos/vue/components/Memberships/MembershipUnredeemableInfo';
import MemberTile from '@/epos/vue/components/Memberships/MemberTile';

export default {
    components: {
        MemberTile,
        MembershipUnredeemableInfo,
    },

    props: {
        /**
         * @type {Membership}
         */
        membership: {
            type: Object,
            required: true,
        },

        /**
         * @type {MembershipSubscription}
         */
        membershipSubscription: {
            type: Object,
            required: false,
            default: null,
        },

        /**
         * @type {Member}
         */
        selectedMember: {
            type: Object,
            required: false,
            default: null,
        },
    },

    emits: [
        'edit-member',
        'toggle-visit',
        'log-visit',
        'unlog-visit',
    ],

    computed: {
        admitAllEnabled() {
            return this.membershipSubscription
                && !this.membershipSubscription.isAtMaximumVisits()
                && this.membership.canBeRedeemedRightNow()
                && this.membership.hasNonRedeemedMembersToday();
        },

        unadmitAllEnabled() {
            return this.membershipSubscription
                && this.membershipSubscription.getVisits() > 0
                && this.membership.isActive()
                && this.membership.hasRedeemedMembersToday();
        },

        membersWithContact() {
            if (!this.membership || !this.membership.members) {
                return [];
            }
            return this.membership.members.filter((member) => member.hasContact());
        },
    },

    methods: {
        handleEditMember(member) {
            this.$emit('edit-member', member);
        },

        handleToggleVisit(member, membershipSubscription, membershipPlan, membership) {
            this.$emit('toggle-visit', member, membershipSubscription, membershipPlan, membership);
        },
    },
};
</script>
